import InputField from 'components/form-fields/formik/InputField';
import { Formik } from 'formik';
import React from 'react';
import { Container, Divider, Form, Header, Button } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { Provider } from 'types/provider';
import { request } from 'utils/api';

const SettingsLookAndFeel: React.FC<{
  provider: Partial<Provider>;
}> = ({ provider }) => {
  const { t } = useTranslation();
  return (
    <Container>
      <Header as="h2" style={{ padding: '0', margin: '0' }}>
        {t('editSandboxLookAndFeel.title', 'Look & Feel')}
      </Header>
      <Divider />
      <p>
        {t(
          'editSandboxLookAndFeel.description',
          'Custom logo, icon and colors'
        )}
      </p>
      <Formik
        enableReinitialize
        initialValues={{
          invertedLogoUrl: provider.invertedLogoUrl,
          logoUrl: provider.logoUrl,
          faviconUrl: provider.faviconUrl,
          primaryColorHex: provider.primaryColorHex,
          primaryColorDarkHex: provider.primaryColorDarkHex,
          secondaryBackgroundColorHex: provider.secondaryBackgroundColorHex,
          secondaryBackgroundColorDarkHex:
            provider.secondaryBackgroundColorDarkHex,
        }}
        onSubmit={(values) => {
          request({
            method: 'PATCH',
            path: `/1/sandboxes/${(provider as any)._id}/settings`,
            body: {
              ...provider,
              ...values,
            },
          });
        }}>
        {({ handleSubmit, isSubmitting, isValid, dirty }) => {
          return (
            <Form>
              <InputField
                name="invertedLogoUrl"
                label={t(
                  'editSandboxLookAndFeel.logoDarkBackground',
                  'Logo URL (Dark Background)'
                )}
              />
              <InputField
                name="logoUrl"
                label={t(
                  'editSandboxLookAndFeel.logoLightBackground',
                  'Logo URL (Light Background)'
                )}
              />

              <InputField
                name="faviconUrl"
                label={t('editSandboxLookAndFeel.faviconURL', 'Favicon URL')}
              />
              <Form.Group widths="equal">
                <InputField
                  name="primaryColorHex"
                  type="color"
                  style={{ padding: '0' }}
                  label={t(
                    'editSandboxLookAndFeel.primaryColor',
                    'Primary Color (Hexadecimal RGB)'
                  )}
                />
                <InputField
                  name="primaryColorDarkHex"
                  type="color"
                  label={t(
                    'editSandboxLookAndFeel.primaryColorDark',
                    'Dark Primary Color (Hexadecimal RGB)'
                  )}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <InputField
                  name="secondaryBackgroundColorHex"
                  type="color"
                  label={t(
                    'editSandboxLookAndFeel.secondaryBackgroundColor',
                    'Secondary Background Color (Hexadecimal RGB)'
                  )}
                />
                <InputField
                  name="secondaryBackgroundColorDarkHex"
                  type="color"
                  label={t(
                    'editSandboxLookAndFeel.secondaryBackgroundColorDark',
                    'Dark Secondary Background Color (Hexadecimal RGB)'
                  )}
                />
              </Form.Group>
              <Button
                disabled={isSubmitting || !isValid}
                onClick={() => handleSubmit()}
                primary>
                {t('save', 'Save')}
              </Button>
            </Form>
          );
        }}
      </Formik>
    </Container>
  );
};

export default SettingsLookAndFeel;
